import React, { HTMLAttributes } from 'react';

export interface SponsorListProps extends HTMLAttributes<HTMLDivElement> {}

const SponsorList: React.FC<SponsorListProps> = (props) => {
	return <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3" {...props} />;
};

export default SponsorList;
